import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Check, Wrench, Droplet, Sparkles } from "lucide-react";

/* 🔥 PROPERTY DATA */
const properties = [
  {
    name: "SoHo Loft",
    location: "New York",
    status: "healthy",
    events: [
      { text: "Cleaning completed", icon: Check, type: "task" },
      { text: "Guest checked in", icon: Check, type: "task" },
    ],
  },
  {
    name: "Downtown Suite",
    location: "Toronto",
    status: "issue",
    events: [
      { text: "Plumbing issue detected", icon: Droplet, type: "issue" },
      { text: "Technician assigned", icon: Wrench, type: "resolve" },
    ],
  },
  {
    name: "Beach Villa",
    location: "Miami",
    status: "healthy",
    events: [
      { text: "Supplies restocked", icon: Sparkles, type: "task" },
      { text: "Ready for guests", icon: Check, type: "task" },
    ],
  },
];

export default function FeatureVisualOperations() {

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const i = setInterval(() => {
      setActiveIndex((p) => (p + 1) % properties.length);
    }, 2200);
    return () => clearInterval(i);
  }, []);

  return (
    <div className="w-full h-full rounded-xl bg-bg-surface p-5 flex flex-col">

      {/* 🔝 HEADER */}
      <div className="flex justify-between items-center mb-4">
        <div>
          <p className="text-small font-semibold text-text-primary">
            Operations Feed
          </p>
          <p className="text-micro text-text-muted">
            Live property activity
          </p>
        </div>

        <motion.span
          className="text-micro text-text-muted"
          animate={{ opacity: [0.6, 1, 0.6] }}
          transition={{ duration: 1.6, repeat: Infinity }}
        >
          Live
        </motion.span>
      </div>

      {/* 🔥 LIST */}
      <div className="flex flex-col gap-3 flex-1">

        {properties.map((property, i) => {
          const isActive = i === activeIndex;
          const event =
            property.events[activeIndex % property.events.length];
          const Icon = event.icon;

          return (
            <motion.div
              key={property.name}
              layout
              initial={{ opacity: 0, y: 8 }}
              animate={{
                opacity: isActive ? 1 : 0.6,
                scale: isActive ? 1 : 0.98,
              }}
              className={`
                card-base p-4 flex items-center justify-between
                ${isActive ? "shadow-card" : ""}
              `}
            >

              {/* LEFT: PROPERTY INFO */}
              <div className="flex flex-col">
                <p className="text-small font-semibold text-text-primary">
                  {property.name}
                </p>
                <p className="text-micro text-text-muted">
                  {property.location}
                </p>
              </div>

              {/* CENTER: EVENT */}
              <motion.div
                key={event.text}
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                className="flex items-center gap-2"
              >
                <div className="
                  w-7 h-7 rounded-full flex items-center justify-center
                  bg-bg-light border border-border-subtle
                ">
                  <Icon size={14} className="text-text-primary" />
                </div>

                <span className="text-small text-text-primary">
                  {event.text}
                </span>
              </motion.div>

              {/* RIGHT: STATUS DOT */}
              <div className="flex items-center gap-2">

                <span className={`
                  w-2.5 h-2.5 rounded-full
                  ${property.status === "issue"
                    ? "bg-brand-secondary"
                    : "bg-brand-primary"}
                `} />

                <span className="text-micro text-text-muted capitalize">
                  {property.status}
                </span>

              </div>

            </motion.div>
          );
        })}

      </div>

      {/* 🔽 FOOTER */}
      <div className="flex justify-between mt-4">

        <span className="text-micro text-text-muted">
          Monitoring all properties
        </span>

        <span className="text-micro font-semibold text-text-primary">
          24/7 active
        </span>

      </div>

    </div>
  );
}